// client/src/pages/Admin/TiptapTestPage.js

import React from "react";
import { TiptapEditor } from "../../../components/TiptapEditor/TiptapEditor";
import { Container, Header } from "semantic-ui-react";

// Importamos directamente los estilos del componente para esta prueba
import "../../../components/TiptapEditor/TiptapEditor.scss";

export function TiptapTestPage() {
  return (
    <Container style={{ paddingTop: "2rem" }}>
      <Header as="h1">Prueba de Concepto (PoC) - Editor Tiptap</Header>
      <p>
        Esta es una página de prueba aislada para verificar el funcionamiento
        del nuevo componente de editor.
      </p>
      <TiptapEditor />
    </Container>
  );
}
